module.exports = __webpack_public_path__ + "img/易⽤的可视化机器学习建模.074b6484.png";